type ImprintPageProps = object;

export const ImprintPage: React.FC<ImprintPageProps> = () => {
  return (
    <div className="container-fluid min-vh-80">
      <h3 className="page-caption mb-3">Impressum</h3>
      <div className="col-xxl-9 col-xl-9 col-lg-9 col-xs-9 mt-0 p-0">
        <p>
          <strong>
            ADM Arbeitskreis Deutscher Markt- und Sozialforschungsinstitute e.V.
          </strong>
          <br />
          Französische Straße 8
          <br />
          10117 Berlin
        </p>
        <p>
          Tel: 030 / 206 16 38 0 <br />
          Fax: 030 / 206 16 38 29
        </p>
        <p>
          E-Mail: office@adm-ev.de <br />
          Internet: www.adm-ev.de
        </p>
        <p>
          Vorstand: Bernd Wachter, Sebastian Götte, Dr. Roland Abold, <br />
          Sitz des Vereins: Berlin <br />
          Registergericht: Amtsgericht Charlottenburg
        </p>
        <p>
          Registernummer: VR 36493 B <br />
          Steuernummer: 45 224 1240 5 – K 03
        </p>
        Für die Inhalte verantwortlich: <br />
        Bettina Klumpe, Geschäftsführerin des ADM Arbeitskreis Deutscher Markt-
        und Sozialforschungsinstitute e.V.
        <p>Graphische Konzeption und Gestaltung: BIK ASCHPURWIS+BEHRENS GMBH</p>
        <p>
          <strong>Rechtshinweis</strong>
          <p>
            Der ADM Arbeitskreis Deutscher Markt- und Sozialforschungsinstitute
            e.V. übernimmt keine Haftung für jedwede materielle oder ideelle
            Schäden, die durch die Nutzung dieses Internetangebots – z.B. durch
            fehlende oder fehlerhafte Informationen – verursacht werden.
          </p>
          <p>
            {" "}
            Der ADM übernimmt keine Gewähr hinsichtlich Aktualität,
            Vollständigkeit oder Korrektheit der angebotenen Inhalte und behält
            sich das Recht vor, die bereitgestellten Inhalte ohne
            Benachrichtigung der Nutzer dieses Angebots zu verändern oder das
            Angebot einzustellen.
          </p>
          <p>
            Sofern der ADM Inhalte Dritter bereit hält oder seine Inhalte mit
            Links auf Internetangebote Dritter hinweisen, haftet der ADM nicht
            für die Inhalte dieser Angebote sowie für mögliche Schäden, die aus
            der Nutzung dieser Internetangebote Dritter entstehen.
          </p>
          <strong>Datenschutzerklärung</strong>
          <p>
            Der Schutz Ihrer Privatsphäre ist für den ADM Arbeitskreis Deutscher
            Markt- und Sozialforschungsinstitute von höchster Bedeutung. Daher
            ist das Einhalten der gesetzlichen Bestimmungen zum Datenschutz für
            uns selbstverständlich.
          </p>
          <p>
            Wenn Sie unsere Webseiten besuchen, speichern unsere Webserver
            standardmäßig den Namen Ihres Internet Service Providers, die
            Webseite, von der aus Sie uns besuchen, die Webseiten, die Sie bei
            uns besuchen sowie das Datum und die Dauer des Besuches. Die
            gespeicherten Daten werden ausschließlich zu statistischen Zwecken
            ausgewertet.
          </p>
          <p>
            Ihre Daten werden vertraulich behandelt und nicht an Dritte
            weitergegeben, weder zu kommerziellen noch zu nichtkommerziellen
            Zwecken.
          </p>
        </p>
      </div>
    </div>
  );
};
